import { useQuery } from "react-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useApiService } from "../useApiService";
import {
  DataTranslationDto,
  DataTranslationValueDto,
  LanguageApi,
} from "../../api";

export function useLanguages() {
  const languageApi = useApiService(LanguageApi);
  const { i18n } = useTranslation();

  const { data, isFetching, refetch } = useQuery(
    "ref-languages",
    async () => {
      return languageApi.getLanguages();
    },
    {}
  );

  const buildDefaultDataTranslations = React.useCallback(async () => {
    const lang = await languageApi.getLanguages();

    const translations = lang.map((l) =>
      DataTranslationValueDto.fromJS({
        languageId: l.id,
        text: "",
        languageCode: l.code,
      })
    );

    return DataTranslationDto.fromJS({
      dataTranslationValues: translations,
    });
  }, [languageApi]);

  const currentLanguage = React.useMemo(() => {
    return data?.find(
      (d) => d.code.toLowerCase() === i18n.language.toLowerCase()
    );
  }, [i18n.language, data]);

  return {
    languages: data ?? [],
    loadingLanguages: isFetching,
    refetchLanguages: refetch,
    buildDefaultDataTranslations,
    currentLanguage,
  };
}
